<template>
  <div class="AddStaff pd-40">
    <SpForm ref="offerForm" v-model="offer" @submit="confirmEmployment">
      <div class="content flex-jc-bt flex-no-wrap">
        <div class="flex-50 left-side">
          <sp-card type="none" custom-class="sp-color-bg-4 pd-20">
            <div style="height: 70px">
              <span v-if="$route.query.jobId" class="clearfix float-r font12 sp-color-7 text-left" style="position: relative; top: -6px">
                {{ $l('CompanyName') }}&nbsp; &nbsp; {{ deptInfo.subNode?.defaultCorp?.name }}
                <br>
                <span style="padding-left: 24px; position:relative; top: 6px">{{ $l('Department') }}&nbsp; &nbsp; {{ deptInfo.name }}</span>
                <br>
                <span style="padding-left: 13px; position:relative; top: 10px" class="sp-color-11">{{ $l('Responsilities') }}&nbsp; &nbsp; {{ selectedJob?.profession?.name }}</span>
                <br>
                <span style="padding-left: 44px; position:relative; top: 14px" class="sp-color-11">{{ $l('Position') }}&nbsp; &nbsp; {{ selectedJob?.position?.name }}</span>
              </span>
              <span v-else class="clearfix float-r font12 sp-color-11 text-left" style="position: relative; top: -6px">
                {{ $l('CompanyName') }}&nbsp; &nbsp; {{ deptInfo.subNode?.defaultCorp?.name }}
                <br v-if="deptInfo.subNode?.defaultCorp?.nativeName">
                <span v-if="deptInfo.subNode?.defaultCorp?.nativeName" style="padding-left: 104px; position:relative;" class="sp-color-7">{{ deptInfo.subNode?.defaultCorp?.nativeName }}</span>
                <br>
                <span style="padding-left: 6px; position:relative; top: 10px" class="sp-color-11">{{ $l('AccessIdentity') }}&nbsp; &nbsp; {{ $l(deptIdentity[deptInfo.identity]?.title) }}</span>
                <br>
                <span style="padding-left: 24px; position:relative; top: 14px">{{ $l('Department') }}&nbsp; &nbsp; {{ deptInfo.name }}</span>
              </span>
            </div>

            <div class="card-content text-left">
              <div class="flex-jc-start">
                <div class="flex-1">
                  <div class="pd-r-20">
                    <div class="">
                      <div class="label-content mg-t-10" style="padding-right: 160px">
                        <p v-required class="fw-bold italic label">{{ $l('PersonalSerialnumber') }}</p>
                        <div class="content flex-al-center flex-jc-start">
                          <div class="flex-1">
                            <spInput v-model="offer.userSerialNo" :disabled="routerQuery.id" placeholder="" height="52" name="userSerialNo" :type="routerQuery.id ? 'gray': 'warn'" />
                          </div>

                          <div class="icon-panel">
                            <span class="icon-magnifier iconfont" style="font-size: 20px" @click="!routerQuery.id && getPersonel(offer.userSerialNo)" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div class="label-content mg-t-10">
                        <p v-required class="fw-bold italic label">{{ $l('MyFullName') }}</p>
                        <div class="content flex-al-center flex-jc-start">
                          <div style="width: 257px">
                            <sp-input v-model="personel.fullName" height="40" :disabled="true" type="gray" />
                            <sp-input v-model="personel.nativeName" height="40" :disabled="true" class="mg-t-5" type="gray" />
                          </div>

                          <div class="icon-panel" />
                        </div>
                      </div>
                      <div class="label-content">
                        <p v-required class="fw-bold italic label" style="padding-left: 47px">{{ $l('NationalityCountryCity') }}</p>
                        <div class="content flex-al-center flex-jc-start">
                          <div class="flex-1 pd-r-10 text-right">
                            <div class="flex-al-center flex-jc-start">
                              <div class="flex-1">
                                <sp-input v-model="personel.country.name" :disabled="true" height="42" type="gray" />
                              </div>
                              <div style="width: 30px">
                                —
                              </div>
                            </div>
                          </div>
                          <div class="flex-1">
                            <sp-input v-model="personel.city.name" :disabled="true" height="42" type="gray" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-jc-bt" style="margin-top: 100px">
                      <SpButton class="mg-r-20" circle-radius="5" :width="244" :type="personel.userId ? 'primary' : 'gray'" :disabled="!personel.userId" :height="59" @click="showDetail = !showDetail">
                        <span class="font-bold font18">{{ $l('Check More Details') }}</span>
                      </SpButton>
                      <SpButton v-if="!routerQuery.id" :type="!addDis ? 'primary' : 'gray'" circle="5" :disabled="addDis" :width="190" :height="59" @click="addOffer">
                        <span class="font-bold font18">{{ $l('Add to the list') }}</span>
                      </SpButton>
                      <SpButton v-if="routerQuery.id" type="primary" circle="5" :width="210" :height="59" @click="goPermissions">
                        <span class="font-bold font18">{{ $l('PermissionSettings') }}</span>
                      </SpButton>
                    </div>
                  </div>
                </div>
                <div style="width: 252px">
                  <div v-if="!$route.query.jobId">
                    <div class="label-content mg-t-10">
                      <p v-required class="fw-bold italic label">{{ $l('Resposibility/Position') }}</p>
                      <div class="content flex-al-center flex-jc-start">
                        <div class="flex-1">
                          <sp-select v-model="offerJobId" required type="warn" height="77" @after-select="getJobInfo">
                            <sp-select-option v-for="job in jobOptions" :key="job.id" :value="job.id" :label="job.profession?.name + ' ' +job.position?.name" type="primary" />
                          </sp-select>
                          <!--                          <sp-input v-else v-model="offerJobName" type="gray" height="77" disabled="true" /> -->
                          <!--                        <spInput v-model="offer.userSerialNo" :validate-reg="/^(?=.*[a-zA-Z])[\w\-().,\' ]{2,64}$/" placeholder="" height="52" required name="userSerialNo" type="warn" /> -->
                        </div>

                        <div class="icon-panel">
                          <el-popover v-if="!routerQuery.id" placement="bottom-start"
                                      :width="140"
                                      trigger="hover">
                            <span class="font12 sp-color-2">{{ $l('AddNewJobTitle') }}</span>
                            <template #reference>
                              <span class="font-bold font18 icon-add iconfont sp-color-11" @click="goAddResponsibilities" />
                            </template>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                    <div class="label-content mg-t-10">
                      <p class="fw-bold italic label">{{ $l('JobDescription') }}</p>
                      <div class="content flex-al-center flex-jc-start">
                        <div class="flex-1">
                          <spInput v-model="offerJobDescription" text-type="textArea" row="15" disabled type="gray" />
                        </div>

                        <div class="icon-panel" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </sp-card>
        </div>
        <div class="flex-49 mg-t-40 pd-20 right-side sp-color-bg-4 text-left" style="margin-left: 20px">
          <div class="flex-jc-bt">
            <div class="">
              <p class="font18 italic-bold">{{ $l('RecruitEmployeeCandidates') }}</p>
              <P class="font16 italic" style="line-height: 22px">
                {{ $l('RecruitmentValidityPeriod') }}
                <sp-input v-model="ttl" :disabled="routerQuery.id" class="ttl-input" :type="routerQuery.id ? 'gray' : 'warn'" width="43" height="22" style="padding-top: 2px; padding-bottom: 2px">48</sp-input>
                {{ $l('Hours ') }}
              </P>
            </div>
            <div class="flex-1 text-right">
              <div class="flex-jc-end">
                <SpButton v-if="!routerQuery.id" type="primary" class="mg-r-20" circle="5" html-type="submit" :disabled="offerLists.length === 0" :width="240" :height="70">
                  <span class="font-bold font18">{{ $l('SendOffer') }}</span>
                </SpButton>
                <SpButton v-if="routerQuery.id" type="primary" class="mg-r-20" circle="5" :disabled="offerLists.length === 0" :width="240" :height="70" @click="confirm('switch')">
                  <span class="font-bold font18">{{ $l('Confirm') }}</span>
                </SpButton>
                <SpButton circle-radius="5" type="back" :width="240" :height="70">
                  <span class="font-bold font18">{{ $l('back') }}</span>
                </SpButton>
              </div>
            </div>
          </div>
          <el-table
            align="center"
            class="mg-t-20 offer-list"
            max-height="500"
            :data="offerLists"
            style="width: 100%"
            :row-style="{ height: '70px' }"
            row-key="id"
            border
          >
            <el-table-column align="center" header-align="center" prop="title" min-width="180" label="Mr/Mrs" />
            <el-table-column align="center" header-align="center" prop="date" min-width="180" label="My Full Name">
              <template #default="scope">
                <div class="sp-color-11">{{ scope.row.fullName }}</div>
                <div v-if="scope.row.nativeName" class="sp-color-7">{{ scope.row.nativeName }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="350" header-align="center" prop="date" min-width="180" label="Nationality Country or SAR  and City">
              <template #default="scope">
                <span class="sp-color-11">{{ scope.row.city?.name }}, {{ scope.row.country?.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" header-align="center" prop="date" width="180" label="State">
              <template #default="scope">
                <div v-if="scope.row.isSend" class="flex-al-center text-center" style="padding-left: 20px">
                  <SpButton v-if="loading" class="font16" type="yellow" height="38" width="114" circle-radius="3">{{ $l('Wait') }}</SpButton>
                  <SpButton v-if="!loading && sendOfferIsSuccess && scope.row.success" class="font16" type="blue" height="38" width="114" circle-radius="3">{{ $l('Sent') }}</SpButton>
                  <SpButton v-if="!loading && sendOfferIsSuccess && !scope.row.success" class="font16" type="error" height="38" width="114" circle-radius="3">{{ $l('Fail') }}</SpButton>
                </div>
              </template>
            </el-table-column>
            <template #empty>
              <div class="noData">
                <P class="font16 sp-color-18 text-center">
                  Click the button "Add to the list" to add the person to this list.
                </P>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <div v-if="personel.userId && showDetail" class="mg-t-20 pd-20 sp-color-bg-4">
        <PersonalDetail :personel="personel" />
      </div>
    </SpForm>
    <el-dialog
      v-model="licenseVis"
      width="30%"
    >
      <div style="font-size: 16px; line-height: 32px;word-break: break-word;">
        Your company have not purchased the license yet.
        Contact Shiplus to buy the license, tel: <span class="sp-color-2">021-63867666</span>
      </div>
      <template #footer>
        <div class="dialog-footer" style="display: block">
          <div class="flex flex-al-end" />
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script type='text/ecmascript-6'>
import spCard from '@/components/common/SpCard'
import spInput from '@/components/common/SpInput'
import spSelect from '@/components/common/SpSelect'
import spSelectOption from '@/components/common/SpSelectOption'
import PersonalDetail from './PersonalDetail'
import {
  getEnterpriseDeptDetailApi,
  getOptionsJobApi,
  getEmployeeDetailApi,
  employeeJobSwitchApi, employeeDismissApi, getEnterpriseJobDetailApi, offerAddApi
} from '@/request/APIs/company'
import { getIndividualInfo } from '@/request/APIs/natural'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpButton from '@/components/common/SpButton'
import { formatLogo } from '@/utils/convert'
import SpForm from '@/components/common/SpForm'
import SpMessage from '@/components/common/SpMessage'
import { DEPT_IDENTITY, IDENTITY_BROKER, IDENTITY_OP } from '@/config/company'
import SpTableDIY from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'

import _includes from 'lodash/includes'
import _forEach from 'lodash/forEach'
import _findIndex from 'lodash/findIndex'
import _filter from 'lodash/filter'
import moment from 'moment'
import { ElNotification } from 'element-plus'
import { getSchemeCurrentApi } from '@/request/APIs/license'

export default {
  name: 'AddStaff',
  nameSpace: 'company.NewEntry',
  components: {
    SpForm,
    SpUploadGroup,
    spCard,
    spInput,
    spSelect,
    spSelectOption,
    SpButton,
    PersonalDetail,
    SpTableDIY,
    SpTableColumn
  },

  data () {
    return {
      deptInfo: {},
      allJobOptions: [],
      jobOptions: [],
      offer: {
        ttl: 48
      },

      personel: {
        country: {
          name: ''
        },

        city: {
          name: ''
        },

        personelPortrait: [
        ]
      },

      selectedJob: {},
      deptIdentity: DEPT_IDENTITY,
      showDetail: false,
      offerLists: [],
      offerJobId: null,
      offerJobName: '',
      offerJobDescription: null,
      ttl: 48,
      loading: false,
      sendOfferIsSuccess: false,
      licenseVis: false
    }
  },

  computed: {
    routerQuery () {
      return this.$route.query
    },

    addStaffPageType () {
      return this.$route.params.type
    },

    // Add to the list按钮不可点击
    addDis () {
      const haveIds = this.offerLists.map(item => item.userId)
      if (!this.personel.userId || (this.personel.userId && _includes(haveIds, this.personel.userId))) {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    'routerQuery.deptId': {
      handler (val) {
        if (val) {
          this.getEnterpriseDeptDetail(this.routerQuery.deptId)
        }
      },

      immediate: true,
      deep: true
    },

    'routerQuery.id': {
      handler (val) {
        if (val && this.$route.name === 'addStaff') {
          getOptionsJobApi().then(res => {
            this.allJobOptions = res.data
            this.jobOptions = _filter(res.data, (i) => parseInt(i.identity) === parseInt(this.deptInfo.identity))
            this.employeeDetail(this.routerQuery.id)
          })
        }
      },

      immediate: true,
      deep: true
    }
  },

  created () {
    this.getOptionsJob()
    if (this.$route.query.jobId) {
      getEnterpriseJobDetailApi(this.$route.query.jobId).then(res => {
        this.offer.jobId = parseInt(this.$route.query.jobId)
        this.selectedJob = res.data
        this.offerJobId = this.offer.jobId
      })
    }
  },

  mounted () {
  },

  methods: {
    // 获取 部门详情
    getEnterpriseDeptDetail (id) {
      getEnterpriseDeptDetailApi(id).then(res => {
        this.$nextTick().then(() => {
          this.deptInfo = res.data
          this.jobOptions = _filter(this.allJobOptions, (i) => parseInt(i.identity) === parseInt(this.deptInfo.identity))
        })
      })
    },

    // 获取职位职位 选项
    getOptionsJob () {
      getOptionsJobApi().then(res => {
        this.allJobOptions = res.data
        this.jobOptions = _filter(res.data, (i) => parseInt(i.identity) === parseInt(this.deptInfo.identity))
      })
    },

    // 获取自然人信息
    getPersonel (userSerialNo) {
      getIndividualInfo(userSerialNo).then(res => {
        console.log(res.data)
        this.personel = res.data
        this.personel.personelPortrait = []
        this.personel.personelPortrait = formatLogo(this.personel, 'avatar')
      }).catch(err => {
        SpMessage({
          message: this.$l('Sorry! The "Personal Serial Number" you entered is incorrect'),
          type: 'error'
        })
      })
    },

    getJobInfo () {
      let job = {}
      if (this.offerJobId) {
        job = this.jobOptions.find(j => j.id === this.offerJobId)
      }
      this.selectedJob = job
      this.offerJobDescription = job.description
    },

    confirmEmployment (params) {
      if (parseInt(this.deptInfo.identity) === IDENTITY_BROKER || parseInt(this.deptInfo.identity) === IDENTITY_OP) {
        getSchemeCurrentApi().then(res => {
          const expiredTime = moment(res.data.expiredTime).format('YYYY-MM-DD')
          const now = moment().format('YYYY-MM-DD')
          // 判断是否过期
          const isExpired = moment(expiredTime).isBefore(moment(now))
          const have = res.data.licenseCount - res.data.usedCount > 0
          if (res.code > 0 && (isExpired || !have)) {
            this.licenseVis = true
          }
        })
      }
      this.loading = true
      const userIds = this.offerLists.map(item => item.userId).join(',')
      if (!this.offerJobId) {
        SpMessage({
          message: 'Resposibility/Position is required',
          type: 'error'
        })
        return
      }

      offerAddApi(userIds, this.offerJobId, this.deptInfo.id, this.ttl).then(res => {
        this.loading = false
        if (res.code > 0) {
          this.sendOfferIsSuccess = true
          _forEach(res.data, (item, index) => {
            const num = _findIndex(this.offerLists, i => parseInt(item.userId) === parseInt(i.userId))
            this.offerLists[num].isSend = true
            this.offerLists[num].success = item.success
            ElNotification({
              title: item.success ? 'success' : 'error',
              message: item.success ? 'success' : item.error,
              type: item.success ? 'success' : 'error',
              offset: 100 * index
            })
          })
        } else {
          SpMessage({
            message: res.message,
            type: 'error'
          })
        }
      })
    },

    // 获取offer详情
    employeeDetail (id) {
      getEmployeeDetailApi(id).then(res => {
        const employee = res.data.employee
        const job = res.data.job
        this.offer.jobId = job?.id
        let selctedJob = {}
        if (this.offer?.jobId) {
          selctedJob = this.jobOptions.find(j => j.id === this.offer.jobId)
        }
        this.selectedJob = selctedJob

        this.offer.description = job.description
        this.offer.userSerialNo = employee.serialNo
        this.showDetail = false
        this.offerJobName = `${res.data.job.profession.name} ${res.data.job.position.name}`
        this.offerJobId = job?.id

        this.offerJobDescription = res.data.job.description

        getIndividualInfo(employee.serialNo).then(res => {
          this.personel = res.data
          this.personel.personelPortrait = []
          this.personel.personelPortrait = formatLogo(this.personel, 'avatar')
          this.offerLists.push({ ...this.offer, ...this.personel })
        })
      })
    },

    confirm (type) {
      // type(switch: 切换)
      employeeJobSwitchApi(this.personel.userId, this.deptInfo.id, this.offerJobId).then(res => {
        SpMessage({
          message: res.message,
          type: 'success'
        })
      })
    },

    confirmDismissal () {
      employeeDismissApi(this.routerQuery.id).then(res => {
        SpMessage({
          message: res.message,
          type: 'success'
        })
      })
    },

    // 往右侧列表中添加数据
    addOffer () {
      const haveIds = this.offerLists.map(item => item.userId)
      if (!_includes(haveIds, this.personel.userId)) {
        this.offerLists.push({ ...this.offer, ...this.personel })
        this.personel = {}
        this.personel = {
          country: {},
          city: {}
        }
        this.$refs.offerForm.clearForm()
      }
    },

    goAddResponsibilities () {
      this.$router.push({ name: 'addResponsibilities', query: { identity: this.deptInfo.identity } })
    },

    goPermissions () {
      this.$router.push({
        name: 'permissionsSetting',
        query: {
          id: this.selectedJob.id
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>
.AddStaff {
    position: relative;
    >.content {
        padding: @gap @gap @gap @gap*2;
        .card-content {
            padding: @gap/2 @gap @gap @gap;
        }
        .person-name {
            padding: @gap*2 @gap*2 0 @gap*2;
        }
    }
    .opacity {
        opacity: .7;
    }
    .submit-btns {
        //position: absolute;
        //left: @gap*1.2;
        //bottom: -@gap*11;
    }
}
.label-content{
  margin-bottom: 16px;
  .label{
    margin: 0;
    position: relative;
    z-index: 99;
  }
  .content{
    margin-top: -4px;
  }
  .icon-panel {
    width: 30px;
    text-align: right;
  }
}
</style>

<style lang="less">
.offer-list{
  .el-table__header{
    .cell {
      font-size: 16px !important;
      font-weight: 600 !important;
    }
  }
  .el-table__body{
    font-size: 16px;
  }
}
.ttl-input input{
  font-style: italic;
}
</style>
